import { ONE_HOUR } from "@/constants/Time";

export const ORGANIZATION_CONTEXT_STALE_TIME = ONE_HOUR;
